import { restApiClient } from '@/datasources';

export interface PUTUpdatePhone {
  status?: number;
  phone: string;
}

export async function updatePhone(body: PUTUpdatePhone) {
  const { data: updateProfileResponse } = await restApiClient.put<PUTUpdatePhone>('/online/customers/phone', body);

  if ((updateProfileResponse).status && (updateProfileResponse).status !== 200) {
    throw new Error('Error updating phone profile');
  }

  return updateProfileResponse;
}
